export default __webpack_public_path__ + "static/media/regulatory--road-closed-to-vehicles--g3.b3970891.png";